/* Loire scent finder: storefront controller. Matching and copy live in scent-finder-core.js. */
if (!customElements.get('scent-finder')) {
  customElements.define('scent-finder', class ScentFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.core = window.LoireScentFinderCore;
      const data = JSON.parse(this.querySelector('[data-scent-data]').textContent);
      this.families = data.families;
      this.perfumes = data.perfumes;
      this.reset();
      this.addEventListener('click', this.onClick.bind(this));
      this.show(1, false);
    }

    reset() {
      this.state = { step: 1, recipient: null, family: null, strength: null };
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button || button.type === 'submit') return;
      const d = button.dataset;
      if (d.recipient) {
        if (d.recipient !== this.state.recipient) Object.assign(this.state, { family: null, strength: null });
        this.state.recipient = d.recipient;
        this.show(2);
      } else if (d.family) {
        if (d.family !== this.state.family) this.state.strength = null;
        this.state.family = d.family;
        this.show(3);
      } else if (d.strength !== undefined) {
        // Tapping the chosen strength again clears the filter.
        const strength = Number(d.strength);
        this.state.strength = strength === this.state.strength ? null : strength;
        this.renderPerfumes();
      } else if (d.variantId) {
        this.selectSize(button);
      } else if (d.action === 'show-all') {
        this.state.strength = null;
        this.renderPerfumes();
        // The button hides itself, so keep keyboard focus on the question instead of losing it.
        this.querySelector('[data-q3]').focus({ preventScroll: true });
      } else if (d.action === 'back') {
        this.show(Math.max(1, this.state.step - 1));
      } else if (d.action === 'restart') {
        this.reset();
        this.show(1);
      }
    }

    choice(title, sub, data, pressed) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'scent-finder__choice';
      Object.keys(data).forEach((key) => { button.dataset[key] = data[key]; });
      button.setAttribute('aria-pressed', String(pressed));
      const strong = document.createElement('strong');
      strong.textContent = title;
      button.append(strong);
      if (sub) {
        const small = document.createElement('small');
        small.textContent = sub;
        button.append(small);
      }
      return button;
    }

    renderFamilies() {
      const prefix = this.core.PATH_BY_RECIPIENT[this.state.recipient] + '_';
      this.querySelector('[data-q2]').textContent = this.core.wording(this.state.recipient).q2;
      const buttons = this.families.filter((f) => f.key.indexOf(prefix) === 0)
        .map((f) => this.choice(f.title, f.subtitle, { family: f.key }, f.key === this.state.family));
      this.querySelector('[data-family-choices]').replaceChildren(...buttons);
    }

    renderStrengths() {
      const w = this.core.wording(this.state.recipient);
      const family = this.families.find((f) => f.key === this.state.family);
      this.querySelector('[data-family-name]').textContent = family ? family.title : '';
      this.querySelector('[data-q3]').textContent = w.q3;
      const buttons = w.strengths.map((s, i) => this.choice(s.title, s.sub, { strength: i }, i === this.state.strength));
      this.querySelector('[data-strength-choices]').replaceChildren(...buttons);
    }

    renderPerfumes() {
      const all = this.core.matchPerfumes(this.perfumes, { family: this.state.family, strength: null }).perfumes;
      const match = this.core.matchPerfumes(this.perfumes, this.state);
      const shown = match.perfumes.map((p) => p.id);
      const filtered = this.state.strength !== null;
      this.querySelectorAll('[data-strength-choices] [data-strength]').forEach((b) => {
        b.setAttribute('aria-pressed', String(Number(b.dataset.strength) === this.state.strength));
      });
      this.querySelectorAll('[data-card-for]').forEach((el) => { el.hidden = shown.indexOf(el.dataset.cardFor) === -1; });
      this.querySelector('[data-cards]').dataset.visible = String(shown.length);
      this.querySelector('[data-empty]').hidden = all.length > 0;
      // A live region, so it stays in the page and only its text changes.
      let closest = '';
      if (filtered && !match.exact) closest = 'אין במשפחה הזו בושם בעוצמה שבחרת. ' + (shown.length === 1 ? 'זה הבושם הכי קרוב אליה:' : 'אלה הבשמים הכי קרובים אליה:');
      this.querySelector('[data-closest]').textContent = closest;
      this.querySelector('[data-action="show-all"]').hidden = !filtered;
      let count = '';
      if (all.length && filtered) count = shown.length + ' מתוך ' + all.length + ' בשמים';
      else if (all.length) count = all.length === 1 ? 'בושם אחד במשפחה' : all.length + ' בשמים במשפחה';
      this.querySelector('[data-count]').textContent = count;
      this.querySelectorAll('[data-trial-for]').forEach((el) => { el.hidden = el.dataset.trialFor !== this.state.recipient; });
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('scent_finder_result', {
          recipient: this.state.recipient,
          family: this.state.family,
          strength: this.state.strength,
          exact: match.exact,
          perfumes: match.perfumes.map((p) => p.handle)
        });
      }
    }

    selectSize(button) {
      const card = button.closest('[data-card-for]');
      card.querySelectorAll('[data-variant-id]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
      card.querySelector('input[name="id"]').value = button.dataset.variantId;
      card.querySelector('[data-price]').textContent = button.dataset.variantPrice;
    }

    show(step, moveFocus = true) {
      this.state.step = step;
      this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = Number(el.dataset.step) !== step; });
      if (step === 1) this.querySelectorAll('[data-recipient]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.recipient === this.state.recipient)));
      if (step === 2) this.renderFamilies();
      if (step === 3) {
        this.renderStrengths();
        this.renderPerfumes();
      }
      this.querySelector('[data-bar]').hidden = step === 1;
      this.querySelector('[data-intro]').classList.toggle('scent-finder__intro--collapsed', step > 1);
      this.querySelector('[data-progress]').textContent = 'שאלה ' + step + ' מתוך 3';
      if (!moveFocus) return;
      // The theme header is sticky, so keep the quiz top (back button, progress) just below it.
      const header = document.querySelector('.section-header');
      const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const top = this.getBoundingClientRect().top;
      if (top < offset) window.scrollBy({ top: top - offset - 8, behavior: 'smooth' });
      const heading = this.querySelector('[data-step="' + step + '"] .scent-finder__question');
      if (heading) heading.focus({ preventScroll: true });
    }
  });
}
